export const imageAndPdfFilter = function(newFile, oldFile, prevent) {
  if (newFile && !oldFile) {
    // validate file extension
    if (!/\.(png|jpg|jpeg|pdf|heic|heif)$/i.test(newFile.name)) {
      return prevent();
    }
  }
};
